<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="600"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer
      ref="collectFormValidator"
    >
      <v-card
        v-if="orderId"
      >
        <v-toolbar flat>
          <v-toolbar-title>回収日の編集</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <v-row
            v-if="forms.can_edit_collected_date"
            dense
          >
            <v-col>
              <v-checkbox
                v-model="forms.past_manifest"
                dense
                label="過去マニフェストの起票"
                hide-details="auto"
              >
              </v-checkbox>
            </v-col>
          </v-row>

          <!-- 回収日 -->
          <v-row>
            <v-col cols="12" md="6">
              <template
                v-if="forms.can_edit_collected_date"
              >

                <cs-date-picker
                  :date.sync="forms.collected_date"
                  :minimum-date="minCollectedDate"
                  :maximum-date="maxCollectedDate"
                  @dateChangedCallback="dateChangedCallback"
                >
                  <template v-slot="{ on, attrs }">
                    <validation-provider
                      v-slot="{ errors }"
                      :rules="{
                        required: true,
                        collectedDateCheck: { past_manifest: forms.past_manifest }
                    }"
                      name="回収日"
                      class="requiredMark"
                    >
                      <v-text-field
                        v-model="forms.collected_date"
                        v-bind="attrs"
                        v-on="on"
                        :error-messages="errors"
                        append-icon="mdi-calendar"
                        clearable
                        dense
                        hide-details="auto"
                        label="回収日"
                        outlined
                        persistent-hint
                        persistent-placeholder
                        readonly
                      />
                    </validation-provider>
                  </template>
                </cs-date-picker>

                <validation-provider
                  v-if="false"
                  v-slot="{ errors }"
                  :rules="{required: true, collectedDateCheck: {past_manifest: forms.past_manifest}}"
                  class="requiredMark"
                  name="回収日"
                >
                  <vue-ctk-date-time-picker
                    v-model="forms.collected_date"
                    :min-date="minCollectedDate"
                    :max-date="maxCollectedDate"
                    no-value-to-custom-elem
                    only-date
                    no-button
                    color="#0070B3"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    no-header
                    auto-close
                  >
                    <v-text-field
                      v-model="forms.collected_date"
                      :error-messages="errors"
                      append-icon="mdi-calendar"
                      clearable
                      dense
                      hide-details="auto"
                      label="回収日"
                      outlined
                      persistent-hint
                      persistent-placeholder
                      readonly
                    />
                  </vue-ctk-date-time-picker>
                </validation-provider>
              </template>
              <div
                v-else
                class="fieldsetLabel"
              >
                <fieldset>
                  <legend>回収日</legend>
                  <span>{{ forms.collected_date | date_format }}&nbsp;</span>
                </fieldset>
              </div>
            </v-col>
          </v-row>
          <!-- /回収日 -->
          <!-- 希望時間 -->
          <v-row>
            <v-col>
              <p class="mb-1">
                希望時間
              </p>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="4" class="dialogDateTimePicker">
              <validation-provider
                v-slot="{ errors }"
                :rules="{preferredStartTimeCheck: {preferred_end_time: forms.preferred_end_time}}"
                name="開始時間"
              >
                <vue-ctk-date-time-picker
                  v-model="forms.preferred_start_time"
                  no-value-to-custom-elem
                  only-time
                  position="top"
                  color="#0070B3"
                  format="HH:mm"
                  formatted="HH:mm"
                  minute-interval="15"
                >
                  <v-text-field
                    v-model="forms.preferred_start_time"
                    :error-messages="errors"
                    append-icon="mdi-clock-time-four-outline"
                    clearable
                    dense
                    label="開始時間"
                    outlined
                    hide-details="auto"
                    placeholder="--:--"
                    persistent-placeholder
                    readonly
                  >
                    <template v-slot:append-outer>
                      <div v-if="$vuetify.breakpoint.mdAndUp">
                        〜
                      </div>
                    </template>
                  </v-text-field>
                </vue-ctk-date-time-picker>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="4" class="dialogDateTimePicker">
              <vue-ctk-date-time-picker
                v-model="forms.preferred_end_time"
                no-value-to-custom-elem
                only-time
                position="top"
                color="#0070B3"
                format="HH:mm"
                formatted="HH:mm"
                minute-interval="15"
              >
                <v-text-field
                  v-model="forms.preferred_end_time"
                  append-icon="mdi-clock-time-four-outline"
                  clearable
                  dense
                  label="終了時間"
                  outlined
                  hide-details="auto"
                  placeholder="--:--"
                  persistent-placeholder
                  readonly
                >
                </v-text-field>
              </vue-ctk-date-time-picker>
            </v-col>
          </v-row>
          <!-- /希望時間 -->
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            color="primary"
            @click="registerButtonClickEvent"
          >
            更新
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
    <send-mail-confirmable-dialog
      :order-id="orderId"
      :enable-dialog="enableMailConfirmableDialog"
      @negativeCallback="negativeCallback"
      @positiveCallback="positiveCallback"
    />
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import SendMailConfirmableDialog from '@/driver/pages/orders/accepts/collection/dialogs/_SendMailConfirmableDialog.vue'

export default {
  name: 'EditCollectDialog',
  components: {
    SendMailConfirmableDialog,
  },
  mixins: [],
  props: {
    orderId: {
      type: Number,
      default: () => null,
    },
    enableDialog: {
      type: Boolean,
      default: () => false,
    }
  },
  data() {
    return {
      enableMailConfirmableDialog: false,
      forms: {
        past_manifest: false,
        collected_date: null,
        preferred_start_time: null,
        preferred_end_time: null,
        can_edit_collected_date: false,
        created_date: null
      },
    }
  },
  computed: {
    /**
     * 回収日
     * 最小日付を算出
     * @returns {string}
     */
    minCollectedDate () {
      return this.$dayjs(this.forms.created_date).subtract(10, 'years').format('YYYY-MM-DD')
    },
    /**
     * 回収日
     * 最大日付を算出
     * @returns {string}
     */
    maxCollectedDate () {
      return this.$dayjs(this.forms.created_date).add(5, 'years').format("YYYY-MM-DD")
    },
  },
  watch: {
    enableDialog (newValue) {
      this.$nextTick(() => this.$refs.collectFormValidator.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
      if (newValue) {
        this.setVariable()
      }
    },
    'forms.collected_date': function (newVal) {
      this.collectedDateChangeEvent(newVal)
    },

  },
  created() {},
  methods: {
    ...mapActions('DriverOrderAcceptCollectionCollect', {
      fetchCollect: 'edit',
      updateCollect: 'update'
    }),
    ...mapActions("DriverOrdersCollectionVerifyCollect", {
      verifyCollect: "update",
    }),
    /**
     * 初期値を取得/設定
     */
    setVariable () {
      this.fetchCollect({ id: this.orderId }).then((content) => {
        this.forms = content
      })
    },
    /**
     * 閉じるボタン クリックイベント
     * @description 呼び出し元で設定されたコールバックを呼び出します.
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    /**
     * 引渡日 チェンジイベント
     * 「過去マニフェストの起票」チェックボックスの制御を行う
     * @param item
     */
    collectedDateChangeEvent(item) {
      const now = this.$dayjs(this.$dayjs().format("YYYY-MM-DD"))
      const date = this.$dayjs(item)
      this.forms.past_manifest = date.isBefore(now);
    },
    /**
     * 回収日変更 コールバック
     * @param date { String } 日付
     */
    dateChangedCallback (date) {
      this.forms.collected_date = date;
    },
    negativeCallback () {
      this.enableMailConfirmableDialog = false;
    },
    positiveCallback () {
      this.updateManifest()
    },
    registerButtonClickEvent () {
      let $self = this
      this.$refs.collectFormValidator.validateWithInfo().then(({ isValid, errors }) => {
        if(isValid) {
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation () {
      let params = this.buildParams();
      this.verifyCollect({ order_id: this.orderId, params: params }).then((content) => {
        if (content.changed) {
          this.enableMailConfirmableDialog = true;
        } else {
          this.updateManifest(params);
        }
      })
    },
    updateManifest () {
      let params = this.buildParams()
      this.updateCollect({ id: this.orderId, params: params }).then(() => {
        this.enableMailConfirmableDialog = false;
        this.$emit('registerCallback')
      })
    },
    buildParams () {
      return {
        past_manifest: this.forms.past_manifest,
        collected_date: this.forms.collected_date,
        preferred_start_time: this.forms.preferred_start_time,
        preferred_end_time: this.forms.preferred_end_time
      }
    },
  }

}
</script>

